'use client'

import cx from 'classnames'
import dynamic from 'next/dynamic'
import { StaticImageData } from 'next/image'

import '@/components/Cart/Molecules/NoveltyCard/NoveltyCard.scss'
import Picture from '@/components/Image/Picture'

const NoveltyCardLogic = dynamic(() => import('@/components/Cart/Molecules/NoveltyCard/NoveltyCardLogic'), {
  ssr: true,
})

export default function NoveltyCard({
  displayName,
  capacity,
  displayLoginAlert,
  label,
  image,
  hidePrice = false,
}: {
  displayName: string
  capacity: string | null
  displayLoginAlert: boolean
  label: string
  image: StaticImageData
  hidePrice?: boolean
}) {
  return (
    <NoveltyCardLogic>
      {(user) => {
        return (
          <div className={cx('u-mb20', 'u-mt20', 'c-cart-noveltyCard')}>
            <div className={cx('c-cart-noveltyCard__main', { 'u-mb10': displayLoginAlert && user == null })}>
              <div className={'c-cart-noveltyCard__image'}>
                <Picture src={image.src} width={image.width} height={image.height} alt={displayName} />
              </div>
              <div className={'c-cart-noveltyCard__content'}>
                <p className={'font-goldenbook u-mb10 c-cart-noveltyCard__title'}>
                  {displayName}
                  {capacity && <span className={'c-cart-noveltyCard__capacity'}>{capacity}</span>}
                </p>

                <div className={'c-cart-noveltyCard__help'}>
                  <div className={'c-cart-noveltyCard__label'}>{label}</div>
                  {!hidePrice && <span className={cx('font-yu-gothic', 'c-cart-noveltyCard__price')}>¥0</span>}
                </div>
              </div>
            </div>
            {displayLoginAlert && user == null && (
              <p className={'c-cart-noveltyCard__alert'}>
                ※ お客様のご購入履歴によっては、{label}の対象外となる場合がございます。
              </p>
            )}
          </div>
        )
      }}
    </NoveltyCardLogic>
  )
}
